import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type GpAwarenessPill from './GpAwarenessPill.tsx';
import type { GpAwarenessPillProps } from './GpAwarenessPillProps.types.tsx';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { STANDARD_EDITION } from '@jira/platform__application-editions/src/edition.tsx';
import { fg } from '@atlassian/jira-feature-gating';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyGPAwarenessPill = lazyForPaint<typeof GpAwarenessPill>(
	() => import(/* webpackChunkName: "async-gp-awareness-pill" */ './GpAwarenessPill.tsx'),
	{ ssr: false },
);

export const AsyncGPAwarenessPill = (props: GpAwarenessPillProps): React.ReactNode => {
	const isSiteAdmin = useIsSiteAdmin();
	const appEditions = useAppEditions();

	// Gate before rendering the lazy component to avoid loading unused code and unnecessary TTAI hold.
	if (
		(!isSiteAdmin || appEditions.serviceDesk !== STANDARD_EDITION) &&
		fg('perf-jsm-issue-view-ttai-horizontal-project-nav')
	) {
		return null;
	}

	return (
		<Placeholder name="horizontal-project-nav" fallback={null}>
			<LazyGPAwarenessPill {...props} />
		</Placeholder>
	);
};
